import { Connector } from '@web3-react/types'
import {
  coinbaseWalletConnection,
  ConnectionType,
  // fortmaticConnection,
  // gnosisSafeConnection,
  injectedConnection,
  networkConnection,
  walletConnectConnection,
} from '.'
import { CoinbaseBadgeIcon, MATICCoinIcon, MetaMaskBadgeIcon, WalletConnectBadgeIcon } from '../components/Icons'

const CONNECTIONS = [
  coinbaseWalletConnection,
  // fortmaticConnection,
  injectedConnection,
  networkConnection,
  walletConnectConnection,
  // gnosisSafeConnection,
]

export function getIsInjected(): boolean {
  return Boolean(window.ethereum)
}

export function getIsMetaMask(): boolean {
  return window.ethereum?.isMetaMask ?? false
}

export function getIsCoinbaseWallet(): boolean {
  return window.ethereum?.isCoinbaseWallet ?? false
}

export function getConnection(c: Connector | ConnectionType) {
  if (c instanceof Connector) {
    const connection = CONNECTIONS.find((connection) => connection.connector === c)
    if (!connection) {
      throw Error('unsupported connector')
    }
    return connection
  } else {
    switch (c) {
      case ConnectionType.INJECTED:
        return injectedConnection
      case ConnectionType.COINBASE_WALLET:
        return coinbaseWalletConnection
      case ConnectionType.WALLET_CONNECT:
        return walletConnectConnection
      // case ConnectionType.FORTMATIC:
      //   return fortmaticConnection
      case ConnectionType.NETWORK:
        return networkConnection
      // case ConnectionType.GNOSIS_SAFE:
      //   return gnosisSafeConnection
    }
  }
}

export function getConnectionName(connectionType: ConnectionType, isMetaMask?: boolean) {
  switch (connectionType) {
    case ConnectionType.INJECTED:
      return isMetaMask ? 'MetaMask' : 'Injected'
    case ConnectionType.COINBASE_WALLET:
      return 'Coinbase Wallet'
    case ConnectionType.WALLET_CONNECT:
      return 'WalletConnect'
    // case ConnectionType.FORTMATIC:
    //   return 'Fortmatic'
    case ConnectionType.NETWORK:
      return 'Network'
    // case ConnectionType.GNOSIS_SAFE:
    //   return 'Gnosis Safe'
  }
}

export function getConnectionIcon(connectionType?: ConnectionType) {
  switch (connectionType) {
    case ConnectionType.INJECTED:
      return <MetaMaskBadgeIcon sx={{ fontSize: "24px" }} />
    case ConnectionType.COINBASE_WALLET:
      return <CoinbaseBadgeIcon sx={{ fontSize: "24px" }} />
    case ConnectionType.WALLET_CONNECT:
      return <WalletConnectBadgeIcon sx={{ fontSize: "24px" }} />
    // case ConnectionType.FORTMATIC:
    //   return 'Fortmatic'
    case ConnectionType.NETWORK:
      return <MATICCoinIcon sx={{ fontSize: "24px" }} />
    // case ConnectionType.GNOSIS_SAFE:
    //   return 'Gnosis Safe'
  }
}